import React from 'react';

import SpinnerIcon from '../../../assets/images/spinner.svg';

import { StreamdownWithEntities } from '../StreamdownWithEntities';
import { Modal } from './Modal';
import { ModalBody } from './ModalBody';

const MarkdownAttachmentModal = ({ downloadUrl, error, fileName, markdown, onClose, status }) => {
  return (
    <Modal
      onClose={onClose}
      padding="none"
      showClose={{ desktop: true, mobile: true }}
      className="border-gray-200 bg-white dark:border-white/10 dark:bg-neutral-950"
    >
      <header className="flex shrink-0 items-center gap-3 border-b border-gray-200 px-5 py-4 pr-14 dark:border-white/10">
        <div className="min-w-0 flex-1">
          <div className="text-3xs font-semibold tracking-wide text-gray-500 uppercase dark:text-neutral-400">Markdown preview</div>
          <h1 className="truncate text-sm font-semibold text-gray-950 dark:text-neutral-100">{fileName || 'Markdown attachment'}</h1>
        </div>
        {downloadUrl && (
          <a
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 cursor-pointer rounded-full bg-gray-100 px-3 py-1.5 text-2xs font-medium text-gray-700 hover:bg-gray-200 dark:bg-neutral-800 dark:text-neutral-200 dark:hover:bg-neutral-700"
          >
            Download original
          </a>
        )}
      </header>

      <ModalBody padding="none" className="min-h-0 bg-white dark:bg-neutral-950">
        <article className="mx-auto min-h-48 w-full max-w-4xl px-6 py-10 md:px-12" aria-busy={status === 'loading'}>
          {(status === 'idle' || status === 'loading') && (
            <div
              className="flex min-h-28 items-center justify-center gap-2 text-sm text-gray-500 dark:text-neutral-400"
              role="status"
              aria-live="polite"
            >
              <SpinnerIcon className="size-5 animate-spin" />
              <span>Loading preview…</span>
            </div>
          )}
          {status === 'error' && (
            <div className="rounded-2xl bg-red-50 p-5 text-sm text-red-700 dark:bg-red-950/40 dark:text-red-200">{error}</div>
          )}
          {status === 'loaded' && <StreamdownWithEntities variant="markdown-document">{markdown}</StreamdownWithEntities>}
        </article>
      </ModalBody>
    </Modal>
  );
};

export default MarkdownAttachmentModal;
